import { Modal, Button } from 'react-bootstrap';
import * as myConst from "../../constants/configurationPageConstants";
import React, { useState, useEffect, useContext } from "react";
import JSZip from 'jszip';
import { AddNewInput, SubmitButton, ValidationComponent } from "../../components/new-resource-form/index.jsx"

const orgList = myConst.orgList;
const azureList = myConst.azureList;
const azureAccountList= myConst.azureAccountList;
const awsAccountList= myConst.awsAccountList;
const awsClusterAdvancedList = myConst.awsClusterAdvancedList;
const githubList = myConst.githubList;
const jenkinsList = myConst.jenkinsList;
const muleEnvList = myConst.muleEnvList;
const grafanaList = myConst.grafanaList;
const bitbucketList = myConst.bitbucketList;
const confluenceList=myConst.confluenceList;
const azureVaultList=myConst.azureVaultList;
const awsList = myConst.awsList;
const vmEc2List = myConst.VMEC2List;
const flexGatewayList = myConst.flexGatewayList;
const registerFlexGatewayList = myConst.registerFlexGatewayList;
const flexBasicAuth = myConst.flexBasicAuth;
const flexRateLimiting = myConst.flexRateLimiting;
const gkeList = myConst.gkeList;
const sonarList= myConst.sonarList;
const gitlabList= myConst.gitlabList;
const elkList=myConst.elkList;
const standardsList=myConst.standardsList;





function AddNewResource(props) {
    console.log("props from accesmanagement in addnew resource",props);
    const submitLabel = props.isEditMode ? 'Update' : 'Submit';
    const [showAdvancedCluster, setShowAdvancedCluster] = useState(false);
    const [apiPathObject, setApiPathObject] = useState([
        {
            label: 'Api Path ',
            stateVal: 'apiPath',
            type: 'text',
        }
    ]);
    function addApiPath() {
        const apiPathObjectLen = apiPathObject.length
        let newObj = {
            label: 'Api Path ' + apiPathObjectLen,
            stateVal: 'apiPath' + apiPathObjectLen,
            type: 'text',
        }
        let newArr = [...apiPathObject, newObj]
        setApiPathObject(newArr);
        let PropsObject = {
            target: {
                name: 'apiPathLength',
                value: newArr.length,
                type: 'text',
                checked: undefined
            }
        }
        props.onChange(PropsObject)
    }
    return (
        <>
            <Modal.Header closeButton className="modal-header">
                <Modal.Title>Add New {(props.activePage === 'Github') ? 'Github Repo' : 'Resources'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {(props.state.activePage === 'Azure' && props.state.activeTab !== 'azCluster') ? <div>
                    {
                        azureAccountList.map(res => {
                            return (
                                <div className="form-content">
                                    <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                    {props.state.azureValidation[res.stateVal] == false ?
                                        <ValidationComponent message='please provide value here' /> : null}
                                </div>
                            )
                        })
                    }
                    <Button type="button" fullWidth variant="contained"
                        className="submit-btn" onClick={() => props.submitResource('azaccount')}>{submitLabel}</Button>
                </div> :
                (props.state.activePage === 'Azure' && props.state.activeTab ==="azCluster") ? <div>
                    {
                        azureList.map(res => {
                            return (
                                <div className="form-content">
                                    <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                    {props.state.azureValidation[res.stateVal] == false ?
                                        <ValidationComponent message='please provide value here' /> : null}
                                </div>
                            )
                        })
                    }
                    <Button type="button" fullWidth variant="contained"
                        className="submit-btn" onClick={() => props.submitResource('azure')}>{submitLabel}</Button>
                </div> : props.state.activePage === 'Github' ? <div>
                    {
                        githubList.map(res => {
                            return (
                                <div className="form-content">
                                    <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                    {props.state.githubValidation[res.stateVal] == false ?
                                        <ValidationComponent message='please provide value here' /> : null}
                                </div>
                            )
                        })
                    }
                    <Button type="button" fullWidth variant="contained"
                        className="submit-btn" onClick={() => props.submitResource('github')}>{submitLabel}</Button>
                </div> :props.state.activePage === 'GitLab' ? <div>
                    {
                        gitlabList.map(res => {
                            return (
                                <div className="form-content">
                                    <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                    {props.state.gitlabValidation[res.stateVal] == false ?
                                        <ValidationComponent message='please provide value here' /> : null}
                                </div>
                            )
                        })
                    }
                    <Button type="button" fullWidth variant="contained"
                        className="submit-btn" onClick={() => props.submitResource('gitlab')}>{submitLabel}</Button>
                </div> :
                    props.state.activePage === 'GKE' ? <div>
                        {/* {
                            gkeList.map(res => {
                                return (
                                    <div className="form-content">                                       
                                        <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                        {props.state.gkeValidation[res.stateVal] == false ?
                                            <ValidationComponent message='please provide value here' /> : null}
                                    </div>
                                )
                            })
                        } */}
                        <div className="form-content">
                            <div className="text-label-wrap">
                                <label className="form-text-label">Service Account Json Key File (required)</label>
                                <input type="file" onChange={props.handleChange} />
                            </div>
                            
                            
                        </div>
                        <Button type="button" fullWidth variant="contained"
                            className="submit-btn" onClick={() => props.submitResource('addgkeaccount')}>{submitLabel}</Button>
                    </div> :
                        props.state.activePage === 'Jenkins' ? <div>
                            {
                                jenkinsList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.jenkinsValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('jenkins')}>{submitLabel}</Button>
                        </div> : 
                        props.state.activePage === 'Sonarqube' ? <div>
                        {
                            sonarList.map(res => {
                                console.log("sonarList",res)
                                return (
                                    <div className="form-content">
                                        <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                        {props.state.sonarValidation[res.stateVal] == false ?
                                            <ValidationComponent message='please provide value here' /> : null}
                                    </div>
                                )
                            })
                        }
                        <Button type="button" fullWidth variant="contained"
                            className="submit-btn" onClick={() => props.submitResource('sonarqube')}>{submitLabel}</Button>
                    </div> :props.state.activePage === 'Mule' ? <div>
                            {
                                muleEnvList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.muleValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('mule')}>{submitLabel}</Button>
                                </div> :props.state.activePage === 'GkeCluster' ? <div>
                            {
                                gkeList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.gkeValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('gkeCluster')}>{submitLabel}</Button>

                        </div> : props.state.activePage === 'Grafana' ? <div>
                            {
                                grafanaList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.grafanaValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('grafana')}>{submitLabel}</Button>
                        </div> : props.state.activePage === 'Bitbucket' ? <div>
                            {
                                bitbucketList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.bitbucketValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('bitbucket')}>{submitLabel}</Button>
                        </div> :  props.state.activePage === 'Confluence' ? <div>
                            {
                                confluenceList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.confluenceValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('confluence')}>{submitLabel}</Button>
                        </div> : props.state.activePage === 'Azure Key Vault' ? <div>
                            {
                                azureVaultList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.azureVaultValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('azKeyVault')}>{submitLabel}</Button>
                        </div> : props.state.activePage === 'Standards' ? <div>
                            {
                                standardsList.map(res => (
                                    <div className="form-content" key={res.stateVal}>
                                        <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                        {props.state.standardsValidation[res.stateVal] == false ?
                                            <ValidationComponent message='please provide value here' /> : null}
                                    </div>
                                ))
                            }
                            <div className="form-content">
                                <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: 'block' }}>Source Type</label>
                                <select
                                    name="standardType"
                                    value={props.state.standardType || 'document'}
                                    onChange={props.onChange}
                                    style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ccc', fontSize: 13 }}
                                >
                                    <option value="document">Upload Document (PDF / Word / Text)</option>
                                    <option value="text">Paste Text</option>
                                </select>
                            </div>
                            {props.state.standardType === 'text' && (
                                <div className="form-content">
                                    <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: 'block' }}>Standard Content</label>
                                    <textarea
                                        name="standardContent"
                                        value={props.state.standardContent || ''}
                                        onChange={props.onChange}
                                        rows={8}
                                        placeholder="Paste your compliance rules or best practices here..."
                                        style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ccc', fontSize: 12, fontFamily: 'monospace', resize: 'vertical' }}
                                    />
                                </div>
                            )}
                            {(props.state.standardType === 'document' || !props.state.standardType) && (
                                <div className="form-content">
                                    <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: 'block' }}>Upload Document</label>
                                    <input
                                        type="file"
                                        accept=".pdf,.doc,.docx,.txt,.md"
                                        onChange={async e => {
                                            const file = e.target.files[0];
                                            if (!file) return;
                                            props.onChange({ target: { name: 'standardName', value: props.state.standardName || file.name.replace(/\.[^.]+$/, ''), type: 'text' } });
                                            const ext = file.name.split('.').pop().toLowerCase();
                                            const arrayBuffer = await file.arrayBuffer();
                                            let text = '';
                                            if (ext === 'pdf') {
                                                if (!window.pdfjsLib) {
                                                    await new Promise((resolve, reject) => {
                                                        const s = document.createElement('script');
                                                        s.src = `${process.env.PUBLIC_URL}/pdfjs.min.js`;
                                                        s.onload = resolve; s.onerror = reject;
                                                        document.head.appendChild(s);
                                                    });
                                                }
                                                window.pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
                                                const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                                                const pages = [];
                                                for (let i = 1; i <= pdf.numPages; i++) {
                                                    const page = await pdf.getPage(i);
                                                    const content = await page.getTextContent();
                                                    pages.push(content.items.map(it => it.str).join(' '));
                                                }
                                                text = pages.join('\n');
                                            } else if (ext === 'docx' || ext === 'doc') {
                                                const zip = await JSZip.loadAsync(arrayBuffer);
                                                const xml = await zip.file('word/document.xml').async('string');
                                                text = xml.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
                                            } else {
                                                text = new TextDecoder().decode(arrayBuffer);
                                            }
                                            props.onChange({ target: { name: 'standardContent', value: text, type: 'text' } });
                                        }}
                                        style={{ fontSize: 13 }}
                                    />
                                    <p style={{ fontSize: 11, color: '#888', marginTop: 4 }}>Supported: PDF, Word (.docx), plain text, Markdown</p>
                                </div>
                            )}
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('standards')}>Save Standard</Button>
                        </div> :(props.state.activePage === 'AWS' && props.state.activeTab === '' || props.state.activeTab === null)  ? <div>
                            {
                                awsAccountList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.awsValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('awsAccount')}>{submitLabel}</Button>
                        </div>:
                        ( props.state.activePage === 'AWS' && props.state.activeTab === 'awsCluster')? <div>
                            {
                                awsList.map(res => {
                                    return (
                                        <div className="form-content" key={res.stateVal}>
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.awsValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <div style={{ margin: '8px 0' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowAdvancedCluster(p => !p)}
                                    style={{ background: 'none', border: '1px solid #aaa', borderRadius: 4, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}
                                >
                                    ⚙️ {showAdvancedCluster ? 'Hide' : 'Edit'} Advanced Config
                                </button>
                            </div>
                            {showAdvancedCluster && awsClusterAdvancedList.map(res => (
                                <div className="form-content" key={res.stateVal}>
                                    <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                </div>
                            ))}
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('aws')}>{submitLabel}</Button>
                        </div> : ( props.state.activePage === 'ELK' )? <div>
                            {
                                elkList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.awsValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('elk')}>{submitLabel}</Button>
                        </div> :(props.state.activePage === 'AWS' && props.state.activeTab === 'ec2' )  ? <div>
                            {
                                vmEc2List.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} customInputData={props.state.ec2List} keyName="AWS_ACCESS_KEY_ID" />
                                            {props.state.vmEc2Validation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('vmec2')}>{submitLabel}</Button>
                        </div> : props.state.activePage === 'Flex Gateway' ? <div>
                            {
                                flexGatewayList.map(res => {
                                    return (
                                        <div className="form-content">
                                            {
                                                res.label === "Anypoint Organization Id" ? <AddNewInput res={res} onChange={props.onChange} state={props.state} customInputData={props.state.mule} keyName="muleOrg" /> : <AddNewInput res={res} onChange={props.onChange} state={props.state} customInputData={props.state.ec2List} keyName="INSTANCE_ID" />
                                            }
                                            {/* <AddNewInput res={res} onChange={props.onChange} customInputData={props.state.ec2List} keyName="INSTANCE_ID"/>                                          */}
                                            {props.state.flexGatewayValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('flexgateway')}>{submitLabel}</Button>
                        </div> : props.state.activePage === 'Register Flex Gateway' ? <div>
                            {
                                registerFlexGatewayList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} customInputData={props.state.flexGateways} keyName="name" />


                                            {props.state.registerFlexGatewayValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })


                            }
                            <div>
                                {
                                    apiPathObject.map(paths => {
                                        return (
                                            <div className="form-content">
                                                <AddNewInput res={paths} onChange={props.onChange} state={props.state} customInputData />


                                                {props.state.registerFlexGatewayValidation[paths.stateVal] == false ?
                                                    <ValidationComponent message='please provide value here' /> : null}
                                            </div>
                                        )
                                    })

                                }
                            </div>

                            <Button type="button" fullWidth variant="contained"
                                className="add-more-path" onClick={addApiPath}>+ Add Api path</Button>
                            <div>
                                {/* <label> Policies</label> */}
                                {props.state.basicAuth ?
                                    <div className="form-content">
                                        {flexBasicAuth.map(basres => {
                                            return (<AddNewInput res={basres} onChange={props.onChange} state={props.state} />)
                                        })}

                                    </div> : null
                                }
                                {props.state.rateLimiting ?
                                    <div className="form-content">
                                        {flexRateLimiting.map(basres => {
                                            return (<AddNewInput res={basres} onChange={props.onChange} state={props.state} />)
                                        })}

                                    </div> : null
                                }
                            </div>

                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('registerflex')}>{submitLabel}</Button>
                        </div> : <div>
                            {
                                orgList.map(res => {
                                    return (
                                        <div className="form-content">
                                            <AddNewInput res={res} onChange={props.onChange} state={props.state} />
                                            {props.state.muleOrgValidation[res.stateVal] == false ?
                                                <ValidationComponent message='please provide value here' /> : null}
                                        </div>
                                    )
                                })
                            }
                            <Button type="button" fullWidth variant="contained"
                                className="submit-btn" onClick={() => props.submitResource('muleorg')}>{submitLabel}</Button>
                        </div>
                }
            </Modal.Body>
        </>
    )
}
export default AddNewResource;